import React, { useEffect, useRef, useState } from "react";
import { Alert, Table, Button } from "react-bootstrap";
import { useToggle } from "../../../hooks";
import { get } from "../../../utils/DeApi";
import Loader from "../../Loader/Loader";
import DeleteIcon from "mdi-react/DeleteIcon";
import EditIcon from "mdi-react/EditIcon";
import "./KeywordTypeList.scss";
import ErrorHandler from "../../ErrorHandler/ErrorHandler";
import KeywordTypeModal from "../KeywordListModal/KeywordTypeModal";

const KeywordTypeListPgm = ({
  refresh = false,
  action = [],
  show = false,
  setAlertShow = () => false,
  user = {},
}) => {
  const [isFetching, toggleIsFetching] =
    useToggle(
      false
    ); /* *** conditional const for showing and hiding loader *** */
  const [keywordTypes, setKeywordTypes] = useState(
    []
  ); /* *** array of all keywords *** */
  const [keywordType, setKeywordType] =
    useState(null); /* *** a single keyword value container *** */
  const [showModal, toggleShowModal] = useToggle(false);
  const [mode, setMode] = useState("Update");
  const subscribedPromises = useRef([]);
  const [error, setError] = useState(null);
  const [msg, setMsg] = useState(null);
  // const [show, setShow] = useState(props.show);
  const [actionType, setActionType] = useState(null);
  // console.log("poooop: ", props)

  const handleEdit = (keywordType) => {
    setMode("Update");
    // setShow(true);
    // setAlertShow(true);
    setKeywordType(keywordType);
  };

  const handleDelete = (keywordType) => {
    setMode("Delete");
    setKeywordType(keywordType);
  };

  /* *** setting modal operation ( below ) *** */
  const handleModalClose = (data, mode = "Delete") => {
    toggleShowModal();
    setKeywordType(null);
    if (data) {
      switch (mode) {
        case "Add":
          setKeywordTypes([data, ...keywordTypes]);
          break;

        case "Update":
          let types = keywordTypes.map((record) => {
            /* *** finding relevant record *** */
            if (record.id === data.id) {
              record.name = data.name; /* *** setting new value here *** */
              setAlertShow(true);
            }
            return record;
          });
          setKeywordTypes(types);
          setActionType(mode.toUpperCase());
          setAlertShow(true); /* *** showing the alert message *** */
          setMsg("Keyword Updated Successfully!");
          break;

        case "Delete":
          setKeywordTypes(
            keywordTypes.filter((rec) => rec.id !== data.id)
          ); /* *** excluding requested record from the record array *** */
          setAlertShow(true); /* *** showing the alert message *** */
          setActionType(mode.toUpperCase());
          setMsg("Keyword Deleted Successfully!");
          break;

        default:
          return;
      }
    }
  }; /* *** end handle-modal-close *** */

  const resetAlert = () => {
    setMsg("");
    setAlertShow(false);
    setMode("");
    setActionType("");
  };

  useEffect(() => {
    if (
      action &&
      action.response &&
      Object.keys(action.response.data).length > 0
    ) {
      let data = action.response.data;
      setMsg(action.response.msg ? action.response.msg : "");
      setActionType("Add");
      if (action.response.msg !== "Keyword Already Exists!") {
        setKeywordTypes((prevState) => [...prevState, data]);
      }
    }
  }, [refresh, toggleIsFetching]);

  /* *** making sure to trigger toggle-show-modal() *** */
  useEffect(() => {
    if (keywordType?.name) {
      toggleShowModal();
    }
  }, [keywordType, toggleShowModal]);

  useEffect(() => {
    if (keywordTypes && keywordTypes.length <= 0) {
      const { promise, cancel } = get("keywordtypesTraining");
      toggleIsFetching();
      promise
        .then((data) => {
          setKeywordTypes(data.data);
        })
        .catch((error) => setError(error))
        .finally(toggleIsFetching);
      subscribedPromises.current.push(
        cancel
      ); /* *** updating array with cancelable of promise *** */
    }
  }, [refresh, toggleIsFetching]);

  useEffect(() => {
    const promises = subscribedPromises.current;
    return () => promises.forEach((cancel) => cancel());
  }, []);

  /* *** check either fetching is finished or not *** */
  if (isFetching) {
    return <Loader />;
  }

  /* *** check if no data found *** */
  if (keywordTypes.length === 0) {
    return <NoData />;
  }

  const AlertMsg = () => {
    return (
      <Alert variant="success" onClose={() => resetAlert()} dismissible>
        <Alert.Heading>Keyword {actionType}</Alert.Heading>
        <p>{msg}</p>
      </Alert>
    );
  };
  /* *** returning content *** */
  return (
    <>
      {error && <ErrorHandler error={error} />}
      {show && <AlertMsg />}
      <Table className="table-hover mt-2" id="keywordListTblId">
        <thead className="table-outline-deal-style-above-rounded">
          <tr>
            <th className="srWidth">Sr.</th>
            <th className="nameWidth">Name</th>
            <th className="actionWidth" style={{ paddingRight: "1.5%" }}>
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {keywordTypes.map((keyType, index) => (
            <KeywordTypeRow
              key={index}
              counter={index}
              keywType={keyType}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          ))}
        </tbody>
      </Table>
      <KeywordTypeModal
        mode={mode}
        keyType={keywordType}
        show={showModal}
        onClose={handleModalClose}
        user={user}
      />
    </>
  );
};

const KeywordTypeRow = ({ keywType, onEdit, onDelete, counter }) => {
  return (
    <tr>
      <td className="srWidth">{counter + 1}</td>
      <td className="nameWidth">{keywType.name}</td>
      <td className="actionWidth">
        {/* edit button is below */}
        <Button
          variant="null"
          size="sm"
          className="p-1 color-deal-style"
          onClick={() => onEdit(keywType)}
        >
          <EditIcon size={20} />
        </Button>
        {/* delete button is below */}
        <Button
          variant="null"
          size="sm"
          className="p-1 color-deal-style"
          onClick={() => onDelete(keywType)}
        >
          <DeleteIcon size={20} />
        </Button>
      </td>
    </tr>
  );
};

const NoData = () => {
  return (
    <Alert className="mt-5" variant="info">
      <h4 className="mb-0">No Keyword to Show.</h4>
    </Alert>
  );
};

export default KeywordTypeListPgm;
